export class IncidentTypeModel {
    id: string;
    value: string;
  result: any[];
  statusCode: any;
  success: boolean;

} 

    